import { isAfter, isBefore, endOfDay, startOfDay, parse } from 'date-fns';

import { TFilter } from '@components';
import { THealthSecurityIncident, TMozambiqueSecurityIncident } from '@types';
import { DATA_VALUES } from '@constants';

export function filterIncidents(
    incidents: THealthSecurityIncident[],
    filter: TFilter,
    filterColumn: string
): THealthSecurityIncident[] {
    return incidents.filter(incident => {
        const matchesCategory =
            filterColumn === DATA_VALUES.HEALTH ||
            incident.eventCategories.includes(filterColumn);

        return (
            matchesCategory &&
            isAfter(
                endOfDay(parse(incident.isoDate, 'dd/MM/yyyy', new Date())),
                startOfDay(new Date(filter.fromDate))
            ) &&
            isBefore(
                startOfDay(parse(incident.isoDate, 'dd/MM/yyyy', new Date())),
                endOfDay(new Date(filter.toDate))
            )
        );
    });
}

export function filterMozambiqueIncidents(
    incidents: TMozambiqueSecurityIncident[],
    filter: TFilter,
    filterColumn: string
): TMozambiqueSecurityIncident[] {
    return incidents.filter(
        incident =>
            incident[filterColumn as keyof TMozambiqueSecurityIncident] !==
                '' &&
            isAfter(
                endOfDay(parse(incident.isoDate, 'dd/MM/yyyy', new Date())),
                startOfDay(new Date(filter.fromDate))
            ) &&
            isBefore(
                startOfDay(parse(incident.isoDate, 'dd/MM/yyyy', new Date())),
                endOfDay(new Date(filter.toDate))
            )
    );
}
